<template>
  <div class="l-case-card" :class='type'>

    <h4 class="title">
        {{ title }}
    </h4>

    <div class="card">

        <div class="summary">
            
            <l-img :src='activeEle.src'></l-img>
            
            <p class="content">
                {{ activeEle.content }}
            </p>
        </div>

        <div class="project-list">
            <l-row :gutter='30'>
                <l-col :span='12' v-for='(item, index) of list' :key='index'>
                    <div class="project" @click='select(item, index)' :class="{ active: item.label === activeEle.label }">
                        <p class="text"> {{ item.label }} </p> 
                    </div>
                </l-col>
            </l-row>
        </div>
    </div>
            
      
  </div>
</template>

<script>


const conf = {
    title: '',
    list: [
        {
            label: '',
            value: '',
            src: '',
            content: ''
        }
    ]
}

export default {
    name: 'l-case-card',
    model: {
        prop: 'active',
        event: 'select'
    },
    props: {

        // 布局类型 [ left, right ]
        type:{
            default: 'left'  
        },
        
        // 当前选中项
        active: {
            default: ''
        },
        
        // 标题
        title: {
            default: ''
        },

        // 信息列表
        list: {
            default: []
        }
    },
    data(){
        return {
            
        }
    },

    computed: {
        activeEle(){
            return this.list.filter((item, index) => item.value === this.active || index === this.active )[0] || {}
        }
    },

    methods:{
        select(activeItem, index){
            this.$emit("select", activeItem.value || index )
            this.$emit("change", activeItem)
        }
    }

}
</script>
<style lang="scss" scoped>

$summaryW: 670px;
$project_interval: 66px;
$project_margin: $summaryW + $project_interval;


.l-case-card{

}

.l-case-card + .l-case-card {
    margin-top: 100px;
}

.title{
    $interval: 6px;
    $iconW: 2px;
    @include font_sub_title;
    display: inline-block;
    position: relative;
    margin-bottom: 60px;
    padding-left: $interval + $iconW; 

    &::before{
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        
        margin: auto;
        width: $iconW;
        height: 14px;
        background: $main_color;
    }
    
}


.l-case-card.left{
    .summary{
        float: right;
    }

    .project-list{
        margin-left: 0;
        margin-right: $project_margin;
    }
}


.card{
    @include clearFloe;
    box-sizing: border-box;
    height: 460px;
    padding: 14px 22px;
    border: 1px solid $color_border;
    .summary{
        float: left;
        position: relative;
        box-sizing: border-box;
        width: $summaryW;
        height: 100%;
        
        .content{
            @include font_content;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            margin: auto;
            box-sizing: border-box;
            padding: 20px 24px 28px;
            background: rgba(0, 0, 0, .5);
            color: $font_color_light;
            
        }
    }

    
    
    .project-list{
        margin-left: $project_margin;
    }

    .project{
        $h: 60px;
        @include text_overflow;
        display: block;
        margin-bottom: 30px;
        box-sizing: border-box;
        padding: 0 16px;
        height: $h;
        border: 1px solid $color_border;
        text-align: center;
        line-height: $h;
        cursor: default;
        transition: all .3s;

        &.active,
        &:hover{
            border-radius: 2px;
            border-color: $main_color;
            .text{
                color: $main_color;
            }
        }

        .text{
          vertical-align:middle;
          @include font_content;
          display: inline-block;
        }
    }
    
}


</style>